import OverloadYield from "./OverloadYield.js";
function _awaitAsyncGenerator(e) {
  return new OverloadYield(e, 0);
}
export { _awaitAsyncGenerator as default };


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/esm/awaitAsyncGenerator.js
// module id = 704
// module chunks = 0